import { render, staticRenderFns } from "./SincronizarRestaurantes.vue?vue&type=template&id=08a18fa6&scoped=true"
import script from "./SincronizarRestaurantes.vue?vue&type=script&lang=js"
export * from "./SincronizarRestaurantes.vue?vue&type=script&lang=js"
import style0 from "./SincronizarRestaurantes.vue?vue&type=style&index=0&id=08a18fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a18fa6",
  null
  
)

export default component.exports